import { useEffect, useContext } from 'react';
import * as Sentry from '@sentry/react'; // eslint-disable-line import/no-namespace

import SharedRenderContext from 'core/components/SharedRenderContext';

import { resolve } from 'core/utils/env';

import { SENTRY_PARAMS } from 'core/site/constants';

import SentryFallback from './SentryFallback';
import ignoreErrorsTemplates from './ignoreErrorsTemplates';


export default function SentryWrapper({ children }) {
  const { requestHeaders: { host } } = useContext(SharedRenderContext);
  const sentryParams = resolve(SENTRY_PARAMS);

  useEffect(() => {
    if (sentryParams) {
      const dsn = `https://${sentryParams.key}@${host}/sentry/${sentryParams.project}`;

      Sentry.init({
        dsn,
        attachStacktrace: true,
        tracesSampleRate: 0.1,
        allowUrls: [
          '://' + host,
          /^\/assets\/main\./,
          /^\/assets\/vendor\./,
        ],
        beforeSend: (e, { originalException }) => {
          const exceptionInterfaceAvailable = e.exception && e.exception.values.length > 0;

          if (exceptionInterfaceAvailable) {
            e.fingerprint = [
              e.exception.values[0].type,
              e.exception.values[0].value,
            ];
          } else if (originalException) {
            e.fingerprint = [
              originalException.message,
            ];
          }

          return e;
        },
        ignoreErrors: ignoreErrorsTemplates,
      });
      Sentry.configureScope(scope => {
        scope.setTag('source', 'client');
        scope.setTag('host', host);
      });
    }
  }, [host, sentryParams]);


  if (!sentryParams) return children;

  return (
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
